import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { DateUtils } from '../../Utils/DateUtils';

var tableId = 'tableGameTransactions';
var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface IndexPageOptions extends PageOptionsBase {
    urlList: string;
}

export class ApprovalPage extends PageBase<IndexPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;

    constructor(options: IndexPageOptions) {
        super(options);

        this.openDialog = this.openDialog.bind(this);

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            columns: [
                {
                    data: 'Type',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnType${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Id',
                    className: "bold",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnName${rowData.Id}'>${data}</a>`)
                },
                {
                    data: 'ExternalParentId',
                    sortable: false,
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnExternalParentId${rowData.Id}'>${data}</a>`)
                },
                {
                    data: 'ReversedBy',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnReversedBy${rowData.Id}'>${data || ''}</span>`),
                },
                {
                    data: 'RealAmount',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnRealAmount${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'BonusAmount',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnBonusAmount${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Status',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnStatus${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Forced',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnForced${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Created',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCreated${rowData.Id}'>${DateUtils.toDefaultWithTime(data)}</span>`)
                },
                {
                    data: 'Completed',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCompleted${rowData.Id}'>${DateUtils.toDefaultWithTime(data)}</span>`)
                },
                {
                    data: 'RemoteId',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnRemoteId${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'RealBalance',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnRealBalance${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'BonusBalance',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnBonusBalance${rowData.Id}'>${data}</span>`)
                }
            ],
            order: [[1, "asc"]]
        };
    }

    private openDialog() {
        document.getElementById("areYouSureConfirmation").hidden = false;
    }
    private closeDialog() {
        document.getElementById("areYouSureConfirmation").hidden = true;
    }

    init(): void {
        // == create 'new Datatable' instance
        this._table = new Datatable(tableId, this._tableOptions);
        var submitButton = <HTMLLinkElement>document.getElementById("lnkReview");
        if (submitButton != null) {
            submitButton.onclick = (e) => {
                e.preventDefault();

                var confirmButton = <HTMLButtonElement>document.getElementById("btnConfirm");
                confirmButton.onclick = () => {
                    window.location.href = submitButton.href;
                };

                var closeButton = <HTMLButtonElement>document.getElementById("btnHideConfirmation");
                closeButton.onclick = () => this.closeDialog();
                this.openDialog();
            };
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Reviews/ApprovalPage.ts
 **/